import React from "react";
import Modal from "react-bootstrap/Modal";
import ReactToPrint from "react-to-print";
import ReactDropdown from "react-dropdown";
import KySoAPI from "service/In/KySoAPI";
import configs from "constants/configs";
import cauHinh from "utils/cauHinh";
import CauHinhApi from "service/cauHinhApi";
class ComponentToPrint extends React.Component {
  render() {
    return (
      <div className="col-sm-12" style={{ width: "100%", color: "#000000" }}>
        <div
          style={{ padding: "15px" }}
          dangerouslySetInnerHTML={{ __html: this.props.data }}
        ></div>
      </div>
    );
  }
}

class InChoVay extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      printContent: "",
      choVayId: 0,
      mauInId: 0,
      ListMauIn: [],
      isCauHinhChuKySo: false,
    };
  }
  componentDidMount() {
    let { getListMauIn } = this.props;
    getListMauIn();
    CauHinhApi.getConfigSys1().then((response) => {
      if (response.status === 200 && response.data.length > 0) {
        const configChuKySo = response.data.find(
          (e) =>
            e.keyConfig &&
            e.keyConfig.toUpperCase() === cauHinh.sKey.IsUseChuKySo.toUpperCase(),
        );
        const isCauHinhChuKySo =
          configChuKySo != null && configChuKySo.valueConfig === "1";
        this.setState({ isCauHinhChuKySo });
      }
    });
  }
  componentDidUpdate() {
    let { getNoiDungIn, data, show } = this.props;
    let { mauInId, choVayId } = this.state;
    if (show && data && data.ChoVayId && data.ChoVayId !== choVayId) {
      this.setState({
        choVayId: data.ChoVayId,
      });
      getNoiDungIn({ mauhopdongId: mauInId, chovayId: data.ChoVayId });
    }
  }
  onChangeMauIn = () => (item) => {
    this.setState({ mauInId: item.value });
    let { getNoiDungIn, data } = this.props;
    getNoiDungIn({ mauhopdongId: item.value, chovayId: data.ChoVayId });
  };

  handleSignAndDownload = async () => {
    try {
      let { mauInId, choVayId } = this.state;

      // 3.5 Lấy thông tin token từ USB
      const tokenInfoRes = await fetch(
        "http://localhost:5000/api/sign/TokenInfo",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
        },
      );

      if (!tokenInfoRes.ok) {
        const errorText = await tokenInfoRes.text();
        throw new Error(errorText || "Lỗi lấy thông tin USB token");
      }

      const tokenInfo = await tokenInfoRes.json();
      console.log("Token info:", tokenInfo);

      // 1. lấy hash từ server
      const data = await KySoAPI.getHash(mauInId, choVayId);
      if (!data || !data.hash) {
        alert("Lỗi ký số hoặc hợp đồng đã ký trước đó");
        return;
      }
      const hash = data.hash;
      console.log("Hash nhận được từ server:", hash);

      // 3. ký USB token
      const signRes = await fetch("http://localhost:5000/api/sign/KySo", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ Hash: hash }),
      });

      // if (!signRes.ok) {
      //   const errorText = await signRes.text();
      //   throw new Error(errorText || "Lỗi ký USB token");
      // }

      const signData = await signRes.json();
      if (!signData || !signData.Signature) {
        throw new Error("Không nhận được chữ ký từ USB token");
      }

      // 4. gửi lại backend để embed
      const signedPdfBlob = await KySoAPI.uploadSignedPDF(
        signData.Signature,
        choVayId,
        hash,
        signData.Certificate,
      );

      // 5. download file đã ký
      const url = window.URL.createObjectURL(signedPdfBlob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "hopdong_signed.pdf";
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error(err);
      alert(err?.message || "Lỗi ký số hoặc hợp đồng đã ký trước đó");
    }
  };

  render() {
    let props = this.props;
    let { inChoVayLoading, onHide, show, inchovay } = props;
    let { ListMauIn, NoiDungIn } = inchovay;
    let { mauInId, isCauHinhChuKySo } = this.state;
    setTimeout(() => {
      window
        .JsBarcode(".barcode")
        .options({
          width: 1,
          height: 26,
          margin: 0,
          fontSize: 15,
        })
        .init();
    }, 500);
    return (
      <Modal
        {...props}
        show={show}
        size="modal-xl modal-xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-new modal fade text-left"
      >
        <Modal.Header>
          <h4 className="modal-title" id="myModalLabel16">
            <span className="btn-icon-right">
              <i className="mdi mdi-table-plus"></i>
            </span>
            In hợp đồng
          </h4>
          <button type="button" className="close-popup-new" onClick={onHide}>
            <i className="mdi mdi-close"></i>
          </button>
        </Modal.Header>
        <Modal.Body className="">
          <div
            className={
              "loader loader-default " + (inChoVayLoading ? "is-active" : "")
            }
          ></div>
          <div class="form tat-toan form-horizontal form-edit">
            <div class="form-body">
              <div class="card collapse-icon accordion-icon-rotate">
                <div
                  class="card-header border-info"
                  data-toggle="collapse"
                  href="#collapse19639"
                  aria-expanded="true"
                  aria-controls="collapse19639"
                >
                  <a class="card-title lead info collapsed" href={() => false}>
                    <h3>Thông tin hợp đồng</h3>
                  </a>
                </div>
                <div
                  id="collapse19639"
                  role="tabpanel"
                  aria-labelledby="headingCollapse9639"
                  class="card-collapse collapse show"
                >
                  <div class="card-content">
                    <div class="card-body">
                      <div className="row">
                        <div class="col-sm-9"></div>
                        <div class="col-sm-3">
                          <br />
                          <ReactDropdown
                            onChange={this.onChangeMauIn()}
                            options={ListMauIn}
                            placeholder="Tất cả"
                            controlClassName="form-control input-sm ml-1 pad-col"
                            value={mauInId}
                          />
                        </div>
                      </div>
                      <div className="row">
                        <ComponentToPrint
                          data={NoiDungIn}
                          ref={(el) => (this.componentRef = el)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="modal-footer button-popup-new-size modal-footer text-right">
          <ReactToPrint
            trigger={() => {
              // NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
              // to the root node of the returned component as it will be overwritten.
              return (
                <a class="btn btn-new-main btn-checknew" href={() => false}>
                  <span class="btn-icon-left">
                    <i class="mdi mdi-printer"></i>
                  </span>{" "}
                  In hợp đồng
                </a>
              );
            }}
            content={() => this.componentRef}
            copyStyles={false}
          />
          {isCauHinhChuKySo && (
            <button
              type="button"
              className="btn btn-new-main btn-checknew"
              onClick={this.handleSignAndDownload}
            >
              <span className="btn-icon-left">
                <i className="mdi mdi-file-pdf"></i>
              </span>
              Ký & Xuất PDF
            </button>
          )}
          <button
            type="button"
            className="btn btn-new-main btn-closenew"
            onClick={onHide}
          >
            <span className="btn-icon-left">
              <i className="mdi mdi-close"></i>
            </span>{" "}
            Đóng
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}
export default InChoVay;
